import React, { SVGProps } from "react";

const BookmarkIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443 388" {...props}>
    <path d="M383.7 44.8 346 82.5l-15-15-15-15-10 10-10 10 25.3 25.3 25.2 25.2 47.8-47.8L442 27.5l-10.3-10.3L421.5 7l-37.8 37.8zM105.3 13.5c-9.9 3-17.8 9.8-22.4 19l-2.4 5-.3 170.4c-.2 154.3-.1 170.3 1.3 169.7.9-.3 32.6-13.9 70.5-30.1 37.9-16.2 69.4-29.5 70-29.5.6 0 32.1 13.3 70 29.5s69.6 29.8 70.4 30.1c1.4.6 1.6-9.1 1.6-97V183h-28l-.2 75.8-.3 75.9-56.7-24.2-56.8-24.3-50.2 21.5c-27.7 11.8-53.3 22.7-57 24.3l-6.8 2.9V41h128V12l-63.2.1c-49.4 0-64.2.3-67.5 1.4z" />
  </svg>
);

export default BookmarkIcon;
